import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'

import { LaunchDarklyProvider } from '@ps/common-features/lib/feature-flags/providers/LaunchDarklyProvider'
import { Logger } from '@ps/common-features/sentry/loggerService'
import '@ps/ds/styles/global.scss'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { UnheadProvider, createHead } from '@unhead/react/client'

import './i18n'
import { router } from './router'

Logger.init(import.meta.env.VITE_SENTRY_DSN_URI, 'resident-portal')

const clientSideId = import.meta.env.VITE_LAUNCHDARKLY_CLIENT_ID
const queryClient = new QueryClient()

const head = createHead()
const root = createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <StrictMode>
    <UnheadProvider head={head}>
      <QueryClientProvider client={queryClient}>
        <LaunchDarklyProvider clientSideId={clientSideId}>
          <RouterProvider router={router} future={{ v7_startTransition: true }} />
        </LaunchDarklyProvider>

        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </UnheadProvider>
  </StrictMode>,
)
